import { Card, CardContent } from "@/components/ui/card"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"

interface RoundOption {
  id: number
  name: string
}

interface PerformanceFiltersProps {
  availableRounds: RoundOption[]
  selectedRoundId: number
  onSelectedRoundIdChange: (roundId: number) => void
  availableTables: number[]
  selectedTable: number[]
  onToggleTable: (table: number) => void
  selectedRoundName?: string
}

export const PerformanceFilters = ({
  availableRounds,
  selectedRoundId,
  onSelectedRoundIdChange,
  availableTables,
  selectedTable,
  onToggleTable,
  selectedRoundName,
}: PerformanceFiltersProps) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
    {/* Seleccionar Ronda */}
    <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
      <CardContent className="p-4">
        <label className="text-sm font-medium text-muted-foreground dark:text-gray-200 mb-2 block">
          Seleccionar Ronda
        </label>
        <Select
          value={selectedRoundId.toString()}
          onValueChange={(value) => onSelectedRoundIdChange(Number(value))}
        >
          <SelectTrigger className="bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-600">
            <SelectValue placeholder="Selecciona una ronda" />
          </SelectTrigger>
          <SelectContent className="bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100">
            {availableRounds.map((round) => (
              <SelectItem key={round.id} value={round.id.toString()}>
                {round.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </CardContent>
    </Card>

    {/* Filtrar por Mesa */}
    <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
      <CardContent className="p-4">
        <label className="text-sm font-medium text-muted-foreground dark:text-gray-200 mb-2 block">
          Filtrar por Mesa
        </label>
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              variant="outline"
              className="w-full justify-between bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 border border-gray-300 dark:border-gray-600"
            >
              {selectedTable.length > 0
                ? `${selectedTable.length} seleccionado(s)`
                : "Todos las mesas"}
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent className="w-56 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100">
            {availableTables.map((table) => {
              const isChecked = selectedTable.includes(table)
              return (
                <DropdownMenuCheckboxItem
                  key={table}
                  checked={isChecked}
                  onCheckedChange={() => onToggleTable(table)}
                  className="dark:text-gray-100"
                >
                  Mesa {table}
                </DropdownMenuCheckboxItem>
              )
            })}
          </DropdownMenuContent>
        </DropdownMenu>
      </CardContent>
    </Card>

    {/* Datos Filtrados */}
    <Card className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700">
      <CardContent className="p-4">
        <div className="text-sm font-medium text-muted-foreground dark:text-gray-200 mb-2">
          Datos Filtrados
        </div>
        <div className="text-lg font-bold text-gray-900 dark:text-gray-100">
          {selectedRoundName}
        </div>
        <div className="text-sm text-muted-foreground dark:text-gray-300">
          {selectedTable.length === availableTables.length
            ? "Todas las mesas"
            : `Mesas ${selectedTable.join(", ")}`}
        </div>
      </CardContent>
    </Card>
  </div>
)
